import Common from '../common/CommonPowerbook';

class TmplObjectWeapon {

    constructor() {
        this.comm = Common.instance;
    }

     make(_d){
         return `
<section class="object object-item">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">공격력 (작은/큰 몬스터)</th>
                    <td>${_d.attack_small} / ${_d.attack_big} </td>
                </tr>
                <tr>
                    <th scope="col">종류</th>
                    <td>${_d.type||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">클래스</th>
                    <td>${(_d.class && _d.class.length)? _d.class.map( item => `<a href="${this.comm.powerbookURL}/${item}">${item}</a>` ).join(', '): ''}</td>
                </tr>
                <tr>
                    <th scope="col">무게</th>
                    <td>${_d.weight||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">한손/양손</th>
                    <td>${_d.style||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">옵션</th>
                    <td>${this.comm.optionList(_d.option)}</td>
                </tr>
                <tr>
                    <th scope="col">재질</th>
                    <td>${_d.material||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">인챈트</th>
                    <td>${this.comm.enchantMaker( _d.enchant )}</td>
                </tr>
                <tr>
                    <th scope="col">손상 여부</th>
                    <td>${_d.crash? '손상됨': '손상되지 않음'}</td>
                </tr>
                <tr>
                    <th scope="col">교환</th>
                    <td>${_d.trade?"가능":"불가능"}</td>
                </tr>
                <tr>
                    <th scope="col">레벨 제한</th>
                    <td>${_d.level_limit||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">설명</th>
                    <td>${_d.description||'-'}</td>
                </tr>
                ${_d.trade?`<tr><td colspan="2"><a href="${this.comm.marketPriceLink(_d.id)}" class="object__price">시세보기</a></td></tr>`:''}
            </tbody>
        </table>
    </article>
</section>`
     }

}

export default TmplObjectWeapon;




// WEBPACK FOOTER //
// ./lineage/TmplObjectWeapon.js